<div class="modal-inner">
    <div class="modal-inner-inner">
        <h1>Wijzig uitvoerder</h1>
        <p>Wijzig de uitvoerder voor {{ data.realisations?.length }} regels</p>
        <input [formControl]="fcPerformerSearch" placeholder="Zoeken in uitvoerders" />
        <div class="results">
            @for (executor of executors$ | async | search: 'name' : fcPerformerSearch.value; track executor.id) {
                <div class="result" (click)="setExecutor(executor)">{{ executor.name }}</div>
            }
        </div>
    </div>
    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
    </div>
    <div class="saving-overlay" *ngIf="saving">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        <div class="saving-text">bezig met opslaan...</div>
    </div>
</div>
